import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import projectsData from "../components/custom/projectData";

import ExploreListProject from "../components/projects/ExploreListProject";
import Preview from "../components/preview/Preview";
import { UseModeProvider } from "../components/custom/useMode";

function ExploreProject() {
  useEffect(() => {
    window.scrollTo(0, 0);
    console.log(window.scrollY);
  }, []);
  const [isLoaded, setLoading] = useState(false);
  const [isClose, setIsClose] = useState(false);

  console.log("Loading ", isLoaded);

  // fetch project url
  const param = useParams().id;
  const projects = projectsData();
  let url = "";
  projects.forEach((project) => {
    if (project.route === param) {
      url = project.linkDemo;
      return "";
    }
  });

  const handleLodingState = () => {
    if (!isLoaded) {
      setLoading(true);
      if (!isClose) {
        setIsClose(true);
      }
    }
  };

  const handleLodingNewproject = () => {
    if (isLoaded) {
      setLoading(false);
    }
  };

  const handleOpenCloseList = () => {
    if (!isClose) {
      setIsClose(true);
    } else {
      setIsClose(false);
    }
  };

  return (
    <>
      <div
        className="d-flex  landing position-relative  back-prev z-3 "
        data-aos="fade-up"
      >
        <UseModeProvider>
          <ExploreListProject
            projects={projects}
            handleLodingNewproject={handleLodingNewproject}
            isClose={isClose}
            handleOpenCloseList={handleOpenCloseList}
          />
          <Preview
            url={url}
            isLoaded={isLoaded}
            handleLodingState={handleLodingState}
          />
        </UseModeProvider>
      </div>
    </>
  );
}

export default ExploreProject;
